export default __webpack_public_path__ + "static/media/small-icon.0eb30cc1.svg";